module.exports = __webpack_public_path__ + "static/media/biaacc3.ce32d844.jpg";